function sanitizeBase(input) {
    if (!input)
        return undefined;
    const trimmed = input.trim();
    if (!trimmed)
        return undefined;
    if (trimmed === '/')
        return '';
    return trimmed.replace(/\/$/, '');
}
function readConfiguredBase() {
    const importMeta = globalThis.importMetaEnv;
    const metaValue = sanitizeBase(importMeta?.VITE_IDP_BASE_URL);
    if (metaValue !== undefined)
        return metaValue;
    const proc = globalThis.process?.env;
    return sanitizeBase(proc?.['VITE_IDP_BASE_URL']);
}
export function resolveIdpUrl(path) {
    const base = readConfiguredBase();
    if (!base) {
        return path;
    }
    if (/^https?:/i.test(path)) {
        return path;
    }
    if (path.startsWith('/')) {
        return `${base}${path}`;
    }
    return `${base}/${path}`;
}
export class IdpRequestError extends Error {
    status;
    constructor(message, status) {
        super(message);
        this.name = 'IdpRequestError';
        this.status = status;
    }
}
export async function postIdpJson(path, payload) {
    const target = resolveIdpUrl(path);
    const response = await fetch(target, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload ?? {}),
    });
    if (!response.ok) {
        let text = '';
        try {
            text = await response.text();
        }
        catch {
            /* ignore */
        }
        throw new IdpRequestError(text || `Request failed (${response.status})`, response.status);
    }
}
//# sourceMappingURL=idp-http.js.map